
import XHeader from 'vux/src/components/x-header/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getKefuInfo } from '../service/getdata'
export default {
data(){
return{
url: null
}
},
components:{
XHeader
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getKefu()
},
methods:{
...mapMutations(['SETTOKEN']),
getKefu(){
var that = this
getKefuInfo({token: this.token}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.url = res.data
console.log(that.url )
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
console.log("error")
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/chat.vue